import axios from "axios";
import store from "./../../store/index";
import { setLogout } from "../../store/reducers/userReducer";

const API_URL_KEY = process.env.REACT_APP_API_URL_KEY || "";

const resolveApiAssetUrl = value => {
	if (!value) {
		return value;
	}

	if (/^https?:\/\//i.test(value)) {
		return value;
	}

	if (!value.startsWith("/")) {
		return value;
	}

	if (!API_URL_KEY) {
		return value;
	}

	const apiOrigin = new URL(API_URL_KEY).origin;
	return `${apiOrigin}${value}`;
};

const api = axios.create({
	baseURL: API_URL_KEY,
	withCredentials: false,
});

const defaultErroeMessage =
	"DY¥?D_D,DúD_¥^D¯Dø D«DæD¨¥?DæD'DýD,D'DæD«D«Dø¥? D_¥^D,DñD§Dø. DYD_Dý¥,D_¥?D,¥,Dæ D¨D_D¨¥<¥,D§¥Ÿ D¨D_DúDDæ.";

const normalizeErrorPayload = (payload, status, fallbackMessage) => {
	let resolvedStatus =
		typeof status === "number" && !Number.isNaN(status) ? status : 0;
	let code = "";
	let message = fallbackMessage;
	let errors = null;

	if (payload) {
		if (typeof payload === "string") {
			message = payload || fallbackMessage;
		} else {
			const payloadStatus = Number(payload.status);
			if (!Number.isNaN(payloadStatus)) {
				resolvedStatus = payloadStatus;
			}
			if (payload.code) {
				code = payload.code;
			}
			if (payload.message) {
				message = payload.message;
			}
			if (payload.errors) {
				errors = payload.errors;
			} else if (payload.validationErrors) {
				errors = payload.validationErrors;
			}
		}
	}

	return {
		status: resolvedStatus,
		code,
		message: message || fallbackMessage,
		errors,
	};
};

api.interceptors.request.use(async config => {
	config.headers = {
		Authorization: localStorage.getItem("token")
			? localStorage.getItem("token")
			: "",
		"ngrok-skip-browser-warning": "true",
		"Access-Control-Allow-Origin": "true",
	};
	return config;
});

api.interceptors.response.use(
	response => {
		const responseStatus = Number(response?.data?.status);
		if (!Number.isNaN(responseStatus) && responseStatus >= 300) {
			return Promise.reject(
				normalizeErrorPayload(response?.data, responseStatus, defaultErroeMessage),
			);
		}

		return Promise.resolve(response?.data);
	},
	error => {
		if (error.code === "ERR_NETWORK") {
			if (localStorage.getItem("user") || localStorage.getItem("token")) {
				logout();
			}
			return Promise.reject(
				normalizeErrorPayload(error.message, 0, defaultErroeMessage),
			);
		}
		if (error.response) {
			if (error.response.status === 401) {
				logout();
				// return Promise.reject(
				// 	"DY¥?D_D,DúD_¥^D¯Dø D«DæD¨¥?DæD'DýD,D'DæD«D«Dø¥? D_¥^D,DñD§Dø. DYD_Dý¥,D_¥?D,¥,Dæ D¨D_D¨¥<¥,D§¥Ÿ D¨D_DúDDæ.",
				// );
				// if (localStorage.getItem("user") || localStorage.getItem("token")) {
				// 	logout();
				// }
			}
			return Promise.reject(
				normalizeErrorPayload(
					error.response.data,
					error.response.status,
					defaultErroeMessage,
				),
			);
		}
		return Promise.reject(
			normalizeErrorPayload(error.message, 0, defaultErroeMessage),
		);
	},
);

const logout = () => {
	localStorage.clear();
	window.location.reload();
	store.dispatch(setLogout(null));
};

class ApiService {
	static getCourses() {
		return api.get(`/course/GetAllCoursesSimple`);
	}
	static getCourseById(courseId) {
		return api.get(`/Course/GetCourseSimple/${courseId}`);
	}
	static getCourseAdvanced(courseId) {
		return api.get(`/Course/GetCourseAdvanced/${courseId}`);
	}
	static getCurrentUser() {
		return api.get(`/user/CurrentWithCourseCheck`);
	}
	static getCurrentUserFromOrderModal() {
		return api.get(`/user/current`);
	}
	static forgotPassword(email) {
		return api.post(`/user/GetRestorePasswordUrl`, {email});
	}
	static restorePassword(data) {
		return api.put(`/user/RestorePassword`, data);
	}
	static checkKey(key, email) {
		return api.get(`/User/AccessRestorePassword?key=${key}&email=${email}`);
	}
	static buyCourse(data) {
		return api.post(`/User/Signup`, data);
	}
	static changePassword(data) {
		return api.put(`/User/UpdatePassword`, data);
	}
	static getAccountPageData() {
		return api.get(`/Course/GetAllCoursesByUser`);
	}

	static signupWithPayment(data) {
		return api.post(`/User/SignupWithPayment`, data);
	}

	static transactionPurchaseCourse({ id, promoCode, provider }) {
		const params = new URLSearchParams();
		if (promoCode) {
			params.append("promoCode", promoCode);
		}
		if (provider) {
			params.append("provider", provider);
		}

		const query = params.toString();
		const url = query
			? `/transaction/purchaseCourse/${id}?${query}`
			: `/transaction/purchaseCourse/${id}`;

		return api.post(url);
	}
	static getMyCourseTransactionStatus(courseId) {
		return api.get(`/transaction/GetMyCourseStatus/${courseId}`);
	}
	static validatePromoCode({ promoCode }) {
		return api.get(`/PromoCode/ValidatePromoCode?code=${promoCode}`);
	}
	static checkEmailIsExist({ email }) {
		return api.get(`/user/IsEmailExists?email=${email}`);
	}
	static downloadZip(endpoint) {
		return api.get(endpoint);
	}
}

export { ApiService, logout };
export { resolveApiAssetUrl };
